import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const TOURNAMENT_REGISTRATION_BASE = `${config.BASE_URL}/tournament-registrations`;
const PAYMENTS_BASE = `${TOURNAMENT_REGISTRATION_BASE}/payments`;
const STUDENTS_BASE = `${TOURNAMENT_REGISTRATION_BASE}/students`;

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

export const getPaymentMeta = async (activeOnly = false) => {
  const q = activeOnly ? "?active_only=true" : "";
  const res = await authFetch(`${PAYMENTS_BASE}/meta${q}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to fetch payment meta");
  }
  return data;
};

export const getPaymentSubTypesByMode = async (modeId) => {
  const res = await authFetch(
    `${PAYMENTS_BASE}/sub-types?payment_mode_id=${encodeURIComponent(String(modeId))}`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to fetch payment sub-types");
  }
  return data;
};

/** Typeahead: matches student name or code (`q` on backend). */
export const searchStudentsForPayment = async (query, limit = 15) => {
  const q = String(query || "").trim();
  if (!q) {
    return { success: true, students: [] };
  }
  const params = new URLSearchParams();
  params.set("q", q);
  params.set("limit", String(limit));
  params.set("page", "1");
  const res = await authFetch(`${STUDENTS_BASE}/search?${params.toString()}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to search students");
  }
  return data;
};
